<template>
  <div
    class="bg-white p-4 rounded-2xl border border-gray-100 flex items-center gap-4"
    :class="{ 'opacity-60': !hasWhatsApp }"
  >
    <div class="w-12 h-12 rounded-xl border border-gray-100 flex items-center justify-center bg-green-50 flex-shrink-0">
      <i class="pi pi-comments text-2xl text-green-500"></i>
    </div>
    <div class="flex-1 min-w-0 text-right">
      <h3 class="font-bold text-gray-900 text-base">בוט WhatsApp ללקוחות</h3>
      <p class="text-xs text-gray-500 leading-snug mt-0.5">
        {{ hasWhatsApp ? 'עונה ללקוחות, קובע ומזיז תורים ומריץ משימות' : 'דרוש חיבור של חשבון WhatsApp Business' }}
      </p>
    </div>
    <InputSwitch
      v-if="hasWhatsApp"
      :modelValue="isEnabled"
      :disabled="loading"
      @update:modelValue="onToggle"
    />
    <i v-else class="pi pi-lock text-gray-400"></i>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useAdminStore } from '@app/stores';
import { SettingsApi } from '@app/api/admin';
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();
const toast = useToast();

const loading = ref(false);
const hasWhatsApp = computed(() => !!adminStore.getBusinessSiteData?.whatsappIntegration?.accessToken);
const isEnabled = computed(() => adminStore.getBusinessSiteData?.whatsappIntegration?.aiEnabled ?? false);

const onToggle = async (enabled: boolean) => {
  trackEvent('whatsapp_bot_toggled', { enabled });
  loading.value = true;
  try {
    await SettingsApi.toggleWhatsappAi(enabled);
    await adminStore.fetchBusinessData();
    toast.success(enabled ? 'בוט WhatsApp הופעל' : 'בוט WhatsApp כובה');
  } catch {
    toast.error('שגיאה בשינוי הגדרת הבוט');
  } finally {
    loading.value = false;
  }
};
</script>
